import {BaseChart} from '../models/chart';

export class Chart implements BaseChart {
  private _chartObj: ApexCharts;

  constructor(ref: any, options: any ) {
    this._chartObj = new ApexCharts(ref, options);
  }

  update(options) {
    this._chartObj.updateOptions(options);
  }

  destroy(): void {
    this._chartObj.destroy();
    this._chartObj = null;
  }

  render(): void {
    this._chartObj.render();
  }

}
